class BoMetaListController {
    constructor($sce, $filter, $sanitize) {
        this.sce = $sce;
        this.filter = $filter;
        this.sanitize = $sanitize;
    }

    trustHtml(string) {
        return this.sce.trustAsHtml(string);
    }

    prepareContentForType(value, type, row) {
        let content = '';

        switch (type) {
            case 'bool':
                content = value ? 'Yes' : 'No';
                break;
            case 'number':
                content = this.filter('number')(value, 2);
                break;
            case 'integer':
                content = this.filter('number')(value, 0);
                break;
            case 'string':
                if(!_.isUndefined(row.enum)) {
                    content = _.get(_.first(this.filter('filter')(row.enum, {key: value})), 'label', '');
                } else {
                    content = value;
                }
                content = this.sanitize(content);
                break;
            default:
                content = value;
                content = this.sanitize(content);
                break;
        }

        return this.trustHtml(content);
    }
}

BoMetaListController.$inject = [
    '$sce',
    '$filter',
    '$sanitize'
];

angular
    .module('festzelt-os.components')
    .controller('BoMetaListController', BoMetaListController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/meta-list/controller.js